import { Injectable } from "@angular/core";
import { ScriptLoaderService } from "./script-loader-service";

@Injectable({ providedIn: "root" })
export class FacebookPixelService {
  constructor(private scriptLoader: ScriptLoaderService) {}

  async init(): Promise<void> {
    await this.scriptLoader.loadScript("https://connect.facebook.net/en_US/fbevents.js");

    await this.scriptLoader.loadInlineScript(`
      if (!window.fbq) {
        window.fbq = function() {
          window.fbq.callMethod ?
            window.fbq.callMethod.apply(window.fbq, arguments) :
            window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
      }

      fbq('init', '234825419539315');
      fbq('track', 'PageView');
    `);

    // Add noscript fallback image manually
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=234825419539315&ev=PageView&noscript=1"/>
    `;
    document.body.appendChild(noscript);
  }
}
